import R from "./objectWithoutPropertiesLoose3.mjs";
import b from "./extends3.mjs";
import * as n from "react";
import { clsx as w } from "./clsx.mjs";
import { pickersYearClasses as c, getPickersYearUtilityClass as $ } from "./pickersYearClasses.mjs";
import { jsx as p } from "react/jsx-runtime";
import f from "./styled.mjs";
import F from "./useThemeProps.mjs";
import _ from "./composeClasses.mjs";
import { alpha as v } from "@mui/system";
const I = ["autoFocus", "className", "children", "disabled", "selected", "value", "tabIndex", "onClick", "onKeyDown", "onFocus", "onBlur", "aria-current", "yearsPerRow"], N = (o) => {
  const {
    disabled: r,
    selected: e,
    classes: a
  } = o;
  return _({
    root: ["root"],
    yearButton: ["yearButton", r && "disabled", e && "selected"]
  }, $, a);
}, O = f("div", {
  name: "MuiPickersYear",
  slot: "Root",
  overridesResolver: (o, r) => [r.root]
})(({
  ownerState: o
}) => ({
  flexBasis: o.yearsPerRow === 3 ? "33.3%" : "25%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center"
})), j = f("button", {
  name: "MuiPickersYear",
  slot: "YearButton",
  overridesResolver: (o, r) => [r.yearButton, {
    [`&.${c.disabled}`]: r.disabled
  }, {
    [`&.${c.selected}`]: r.selected
  }]
})(({
  theme: o
}) => b({
  color: "unset",
  backgroundColor: "transparent",
  border: 0,
  outline: 0
}, o.typography.subtitle1, {
  margin: "6px 0",
  height: 36,
  width: 72,
  borderRadius: 18,
  cursor: "pointer",
  "&:focus": {
    backgroundColor: o.vars ? `rgba(${o.vars.palette.action.activeChannel} / ${o.vars.palette.action.focusOpacity})` : v(o.palette.action.active, o.palette.action.focusOpacity)
  },
  "&:hover": {
    backgroundColor: o.vars ? `rgba(${o.vars.palette.action.activeChannel} / ${o.vars.palette.action.hoverOpacity})` : v(o.palette.action.active, o.palette.action.hoverOpacity)
  },
  "&:disabled": {
    cursor: "auto",
    pointerEvents: "none"
  },
  [`&.${c.disabled}`]: {
    color: (o.vars || o).palette.text.secondary
  },
  [`&.${c.selected}`]: {
    color: (o.vars || o).palette.primary.contrastText,
    backgroundColor: (o.vars || o).palette.primary.main,
    "&:focus, &:hover": {
      backgroundColor: (o.vars || o).palette.primary.dark
    }
  }
})), W = /* @__PURE__ */ n.memo(function(r) {
  const e = F({
    props: r,
    name: "MuiPickersYear"
  }), {
    autoFocus: a,
    className: i,
    children: y,
    disabled: l,
    selected: k,
    value: s,
    tabIndex: m,
    onClick: C,
    onKeyDown: x,
    onFocus: g,
    onBlur: P,
    "aria-current": B
    // We don't want to forward this prop to the root element
  } = e, Y = R(e, I), u = n.useRef(null), d = N(e);
  return n.useEffect(() => {
    a && u.current.focus();
  }, [a]), /* @__PURE__ */ p(O, b({
    className: w(d.root, i),
    ownerState: e
  }, Y, {
    children: /* @__PURE__ */ p(j, {
      ref: u,
      disabled: l,
      type: "button",
      role: "radio",
      tabIndex: l ? -1 : m,
      "aria-current": B,
      "aria-checked": k,
      onClick: (t) => C(t, s),
      onKeyDown: (t) => x(t, s),
      onFocus: (t) => g(t, s),
      onBlur: (t) => P(t, s),
      className: d.yearButton,
      ownerState: e,
      children: y
    })
  }));
});
export {
  W as PickersYear
};
//# sourceMappingURL=PickersYear.mjs.map
